var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMemberTypeExternalStaffBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.125,
    y: 1.125,
    width: 9.75,
    height: 9.75,
    rx: 2.76923,
    fill: "#0064E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberTypeExternalStaffBlue);
export default __webpack_public_path__ + "static/media/MemberTypeExternalStaffBlue.62aebd9df97864ed134b7058992521bc.svg";
export { ForwardRef as ReactComponent };